var render = function render(_c, _vm) {
  return _c(
    "btn",
    _vm._g(
      {
        staticClass: "m-b-10 m-r-5",
        attrs: {
          type: "secondary",
          size: "sm",
          title: `Click to add ${_vm.props.filter} filter`
        }
      },
      _vm.listeners.click ? { click: _vm.listeners.click } : null
    ),
    [
      _c("i", { staticClass: "fa fa-filter" }),
      _vm._v("\n  " + _vm._s(_vm.props.filter) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }